AuthRoute          = require 'mixins/authenticated-route'

App.DeliveryCouriersCarriersRoute = Em.Route.extend AuthRoute,
  env:          Em.inject.service 'environment'
  inappSupport: Em.inject.service()

  redirect: ->
    unless @get 'env.features.externalTransports'
      @transitionTo 'delivery.couriers'

  model: ->
    @store.find 'carrier'

  actions:
    applyForCarrier: (carrierName) ->
      # todo i18n
      @get('inappSupport').initiateDialogue("Прошу подключить перевозчика #{carrierName}")
      false
